import { FeeGroup } from '@givebacks/api/store';
import { Stack } from 'ui';

import { centsToDollar } from '../../../utils';
import { OrderLineItem } from '../../molecules/OrderLineItem/OrderLineItem';

// This map translates the fee_group type to a OrderBlock header that will show in the UI
const FEE_GROUP_HEADER_MAP = {
  Item: 'Store Item ',
  // TODO: (CART FEES) The backend doesn't differentiate between athons and crowdfunding campaigns here.
  Fundraiser: 'Campaign Donation',
  Donation: 'Cause Donation',
  StudentFee: 'Student Fees',
};

const PLEDGE_FEE_TEXT = 'Calculated after event';

type OrderBlockProps = {
  feeGroup: FeeGroup;
  isPledge?: boolean;
};

const OrderBlockContainer = ({ children }: { children: React.ReactNode }) => {
  return (
    <Stack gap={4} w="100%">
      {children}
    </Stack>
  );
};

const OrderBlock = ({ feeGroup, isPledge }: OrderBlockProps) => {
  const blockTitle = `${FEE_GROUP_HEADER_MAP[feeGroup.type]} ${
    feeGroup.items.length ? `(Qty: ${feeGroup.items.length})` : ''
  }`.trim();

  return (
    <OrderBlock.Container>
      <OrderLineItem.Header label={blockTitle} />
      <OrderLineItem.Item label="Subtotal" value={centsToDollar(feeGroup.subtotal)} />

      {feeGroup.fee !== undefined ? (
        <OrderLineItem.Item
          label="Fees"
          value={isPledge ? PLEDGE_FEE_TEXT : centsToDollar(feeGroup.fee ?? 0)}
        />
      ) : null}

      {feeGroup.tip !== undefined ? (
        <OrderLineItem.Item label="Tip" value={centsToDollar(feeGroup.tip ?? 0)} />
      ) : null}
    </OrderBlock.Container>
  );
};

OrderBlock.Container = OrderBlockContainer;

export { OrderBlock };
